import { AxiosError } from "axios";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { apisiseci } from "../../api";
import { TotemGenerateToken } from "../../../@types/totem";

export function useTotemGenerateToken(options?: { enabled: boolean }) {
    const token = localStorage.getItem("gov_access_token_sso");

    return useQuery<TotemGenerateToken, AxiosError<{ detail: string }>>({
        cacheTime: 0,
        staleTime: 0,
        enabled: !!token && (options ? options.enabled : true),
        queryKey: ['totem', 'generate-token'],
        queryFn: async () => {
            const response = await apisiseci.get<TotemGenerateToken>(
                `/cms/gerar_token/`,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            return response.data;
        },
    });
}
